import React from 'react';
import { Link } from '@core/js/components/common/Link';
import { clsx } from '@core/js/utils/classNames.util';
import { componentService } from 'js/services/component.service';

import * as Types from './types';
import * as constants from '@core/js/components/common/Button/constants';
import { Button as NewButton } from './components/Button';

import style from './Button.scss';

export const Button: React.FC<Types.TButtonProps> = ({
    href,
    size,
    children,
    className,
    classname,
    classNamesProps, /* TotalCasino changes */
    buttonRef,
    isNew = false,
    type = 'button',
    view = constants.VIEWS.primary,
    color = constants.COLORS.success,
    status = constants.STATUSES.default,
    variant = constants.VARIANTS.regular,
    ...props
}) => {
    const { VIEWS, VARIANTS, COLORS, SIZES, STATUSES } = constants;
    const classNames = clsx([
        className,
        classname,
        style.btn,
        style[SIZES[size || constants.SIZES.large]],
        style[VIEWS[view]],
        style[COLORS[color]],
        style[STATUSES[status]],
        style[VARIANTS[variant]]
    ]);

    if (isNew) {
        return (
            <NewButton
                type={type}
                href={href}
                size={size}
                view={view as Exclude<keyof typeof constants.VIEWS, 'readonly'>}
                color={color as Exclude<keyof typeof constants.COLORS, 'info' | 'revert' | 'generic'>}
                className={className}
                classNamesProps={classNamesProps} /* TotalCasino changes */
                {...props}
            >
                {children}
            </NewButton>
        );
    }

    return href
        ? (
            <Link
                href={href}
                className={classNames}
                {...props}>
                {children}
            </Link>
        )
        : (
            <button
                type={type}
                className={classNames}
                {...buttonRef && { ref: buttonRef }}
                {...props}>
                {children}
            </button>
        );
};

componentService.registerWebContentComponents({ Button });
